import React from 'react';
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from '@material-ui/core';
import BasicLayout from 'pages/layout/BasicLayout';

interface ComponentProps {
  backgroundColor?: string;
}

export const LoadingFallback = (props: ComponentProps) => {
  const classes = useStyles();
  const { backgroundColor } = props;
  return (
    <BasicLayout backgroundColor={backgroundColor ? backgroundColor : '#fff'}>
      <div
        className={classes.container}
      >
        <CircularProgress color="secondary" />
      </div>
    </BasicLayout>
  );
}

const useStyles = makeStyles(theme => {
  return ({
    container: {
      display: 'flex',
      flexDirection: 'column',
      height: '80vh',
      overflow: 'hidden',
      justifyContent: 'center',
      alignItems: 'center',
    },
  });
});
